import { useNavigate, useParams } from "react-router-dom"
import { useEffect, useState } from "react"
import { toast } from "react-toastify"
import PageContent from "~components/PageContent"
import UserDetail from "~components/users/UserDetail"
import { UserShape } from "~shapes/user"
import BackLink from "~components/BackLink"
import PATHS, { getFullPath } from "~constants/paths"
import useUserByEmail from "~hooks/useUserByEmail"
import { SearchOptionShape } from "~pages/private/create-portfolio"
import TableSearchField from "~components/TableSearchField"
import FlexRow from "~components/FlexRow"

const User = () => {
  const { email } = useParams<{ email: string }>()
  const decodedEmail = decodeURIComponent(email || "")
  const usersPath = getFullPath(PATHS.users)
  const [user, setUser] = useState<UserShape>(null!)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const navigate = useNavigate()

  const navToUsers = () => navigate(usersPath)

  const { refetch: fetchUser, isError: isErrorFetchingUser } = useUserByEmail(
    decodedEmail.trim(),
    setUser
  )

  useEffect(() => {
    if (isErrorFetchingUser) {
      toast.error("Error loading user details")
      navToUsers()
    }
  }, [isErrorFetchingUser])

  useEffect(() => {
    if (!isLoading && !user && !isErrorFetchingUser) {
      toast.warn(`There is no user with email: ${decodedEmail}`)
      navToUsers()
    }
  }, [user, isLoading])

  useEffect(() => {
    setIsLoading(true)
    ;(async () => {
      if (decodedEmail) {
        await fetchUser()
        setIsLoading(false)
      }
    })()
  }, [decodedEmail])

  const onSearch = (el: SearchOptionShape) => {
    const encodedEmail = encodeURIComponent(el.email)
    navigate(`${usersPath}/${encodedEmail}`)
  }
  return (
    <PageContent>
      <FlexRow
        style={{
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 10,
        }}
      >
        <BackLink text="Back to Users" path={usersPath} />

        <div
          style={{
            flex: 1,
            display: "flex",
            justifyContent: "center",
            paddingRight: 150,
          }}
        >
          <TableSearchField
            callback={onSearch}
            searchBy={["email"]}
            placeholder={"Search by email..."}
            searchOnType={false}
            showClearButton={true}
            showSearchIcon={true}
            initialValue={""}
          />
        </div>
      </FlexRow>

      <UserDetail user={user} isLoading={isLoading} updateUser={setUser} />
    </PageContent>
  )
}

export default User
